  document.addEventListener('DOMContentLoaded', function () {
    const serviceItems = document.querySelectorAll('.service-item');
    let selectedItems = []; // Array to store selected items
    let total_span = document.querySelector("#drawer-cart-total");
    
    // Ensure totalPrice starts as a valid number
    let totalPrice = total_span ? parseFloat(total_span.innerText.replace(/[^\d.-]/g, '')) || 0 : 0;

    serviceItems.forEach((item) => {
      item.addEventListener('click', function () {
        const variantId = this.getAttribute('data-variant-id');
        const price = parseFloat(this.getAttribute('data-price').replace(/[^\d.-]/g, '')); // Ensure valid price

        // Check if the item is already in the selectedItems array
        const index = selectedItems.findIndex((item) => item.variantId === variantId);

        if (index > -1) {
          // If the item is already selected, remove it from the array and subtract the price
          selectedItems.splice(index, 1);
          totalPrice -= price; // Update the total price
          updateUI('remove', variantId, this); // Update UI to reflect removal
        } else {
          // If the item is not selected, add it to the array and add the price
          selectedItems.push({ variantId, price });
          totalPrice += price; // Update the total price
          updateUI('add', variantId, this); // Update UI to reflect addition
        }

        updateTotalPrice(); // Update the total price display
      });
    });

    // Function to update the UI based on the action (add/remove)
    function updateUI(action, variantId, element) {
      if (action === 'add') {
        element.classList.add('selected');
      } else if (action === 'remove') {
        element.classList.remove('selected');
      }
    }

    // Function to update and display the total price of selected items
    function updateTotalPrice() {
      const totalElement = document.getElementById('drawer-cart-total'); 
      const formattedPrice = new Intl.NumberFormat('en-IN').format(totalPrice);
      totalElement.textContent = `${formattedPrice}`; // Display total price in currency format
    }

    // Tab switching functionality (for the buttons and content)
    const buttons = document.querySelectorAll('.btn');
    const contents = document.querySelectorAll('.cnt');
    let activeButton = document.querySelector('.btn.active');
    let activeContent = document.querySelector('.cnt:not([hidden])');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-target'); // Get the target content ID

        if (activeButton) {
          activeButton.classList.remove('active'); // Remove 'active' from the current button
        }

        // Add 'active' to the clicked button
        button.classList.add('active');
        activeButton = button; // Update the active button reference

        // Hide all content divs
        contents.forEach((content) => {
          content.hidden = true; // Hide the content
        });

        // Show the target content
        const targetContent = document.getElementById(targetId);
        targetContent.hidden = false; // Show the specific content

        activeContent = targetContent;
        next_btn_ui();
      });
    });

    const nextButton = document.querySelector('.drawer-next-btn');
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        // Find the index of the active button
        next_btn_ui();
        const activeIndex = Array.from(buttons).indexOf(activeButton);

        if (activeIndex === buttons.length - 1) {
          add_To_Cart();
        } else {
          // Trigger the next button click behavior
          const nextIndex = (activeIndex + 1) % buttons.length;
          buttons[nextIndex].click();
        }
      });
    }

    function next_btn_ui() {
      if (activeContent.id === 'upgrades') {
        document.querySelector('.nxt-btn').innerText = 'Go to Cart';
      } else {
        document.querySelector('.nxt-btn').innerText = 'NEXT';
      }
    }

    function add_To_Cart() {
      const itemsToAdd = selectedItems.map((item) => ({
        id: item.variantId, // The variant ID
        quantity: 1, // Ensure quantity is always set to 1
      }));

      let formData = {
        items: itemsToAdd,
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          window.location.href = '/cart'; // Redirect to the checkout page
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  });
